import React, { useEffect, useState } from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Text } from 'apps/auth/components/common/Text/Text';

import styles from './EmptyScreen.module.css';

interface EmptyScreenProps {
    emptyImage: string;
    fallback: React.ReactNode;
    country: string;
    text: string;
    rateText: string;
    onRateClick: React.MouseEventHandler<HTMLButtonElement>;
}

const EmptyScreen: React.FC<EmptyScreenProps> = (props) => {
    const [hasImageError, setHasImageError] = useState(false);

    useEffect(() => {
        setHasImageError(false);
    }, [props.emptyImage]);

    return (
        <>
            <div className={styles.emptyScreenImg}>
                {hasImageError ? props.fallback : <img src={props.emptyImage} alt="mainImage" onError={() => setHasImageError(true)} />}
            </div>
            <Text variant={'div'} size={'header'} indent={'12px'}>
                {props.text}
            </Text>
            <div className={styles.rateButton}>
                <Button variant={'secondary_emphasized'} size={'tight'} onClick={props.onRateClick}>
                    {props.rateText}
                    <Icon name="arrow-forward-rounded" color="secondary_emphasized" leftIndent={'8px'} />
                </Button>
            </div>
        </>
    );
};

export default EmptyScreen;
